// ==========================================================================
// Entry file
// ==========================================================================

let isEdge = new RegExp('Edge/').test(navigator.userAgent);
if (isEdge) window.fetch = false;

import 'babel-polyfill';
import 'formdata-polyfill';
import ('whatwg-fetch');
import './utils/polyfill.nodelist.foreach.js';
import './utils/polyfill.element.matches.js';
import './utils/polyfill.array.includes.js';

import './modernizr';

// App modules
import './django-ajax-jquery';
import './language-selector';
import './book';
import './checkout';
import './navigation-desktop';
import './navigation-mobile';
import './navigation-mobile-user-profile';
import './navigation-minimap';
import './header-message';
import './prevent-submit';
import { cardCarousel } from './carousels';
//import { accordion } from './accordion';
import tabs from './tabs';
import './menu-display';
import filterItems from './filter-items';
import { tooltips } from './tooltips';

import bindDateFields from './date-fields';
import { asyncForm } from './async-form';
import './cancel-update';
import './clear-input';
import './scroll-events';
import './scroll-to-hashtag';
import './scroll-to-top';
import './scroll-events';
import './currency-selector';
import { linkModals } from './modals/link_modals';
import { create_widgets } from './widgets/create_widgets';
import { newsGallery } from './news-gallery';
import './lazy-load';
import { patronChat } from './widgets/patron-chat-modal';
import './get-menu-category';
import togglePasswordFieldType from './toggle-password-field-type';

//import(/* webpackChunkName: "modal"*/ './modal');
import Searchbar from './searchbar';
const searchbar = new Searchbar();
searchbar.init();


// import(/* webpackChunkName: "searchbar"*/ './searchbar').then(module =>
//   module.searchbar.init(),
// );


if (document.querySelector('.js-new-map')) {
  import(/* webpackChunkName: "new-map"*/ './new-map');
}

cardCarousel('.card-carousel-gallery');
cardCarousel('.card-carousel-gallery-mobile');
//accordion.init();
tabs.init();
filterItems.init();
tooltips.init();
bindDateFields();
asyncForm.init();
linkModals();
create_widgets();
newsGallery();
patronChat.init();

togglePasswordFieldType(document.querySelectorAll('.passwordInputField__Wrapper'));


// WEBPACK FOOTER //
// ./src/js/app.js